import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

export default function Layout({ user, permissions, onLogout, isImpersonating }) {
  return (
    <div className="flex h-screen bg-[#FAFAF7]">
      <Sidebar user={user} permissions={permissions} onLogout={onLogout} isImpersonating={isImpersonating} />
      <div className="flex-1 overflow-auto flex flex-col min-w-0">
        {/* Mobile top spacer for fixed header */}
        <div className="lg:hidden h-12 shrink-0" />
        {isImpersonating && (
          <div className="bg-[#8B5CF6] text-white px-4 sm:px-6 py-2 flex items-center justify-between" data-testid="impersonation-banner">
            <p className="text-xs sm:text-sm font-medium">
              Viewing as <strong>{user.name}</strong> ({user.role})
            </p>
            <button onClick={onLogout} className="text-xs sm:text-sm underline font-medium hover:opacity-80" data-testid="stop-impersonation-button">
              Return to Admin
            </button>
          </div>
        )}
        <div className="flex-1 min-w-0">
          <Outlet />
        </div>
        <footer className="bg-[#0A0A0A] py-3 text-center border-t border-black" data-testid="app-footer">
          <p className="text-xs sm:text-sm text-white/70 tracking-wide">Created and Developed by <span className="text-[#C9A961] brand-mark text-base sm:text-lg tracking-widest ml-1">SARAN</span></p>
        </footer>
      </div>
    </div>
  );
}
